module.exports = __webpack_public_path__ + "static/media/sub_no_eat.58eeb981.png";